import { useCallback } from 'react';

import { useSelector } from './useSelector';
import { TRootState, TCustomSelector, TEqualityFunction } from '../types';

export const useCustomSelector = <
    TSelected,
    TReducerName extends keyof TRootState
>(
    reducerName: TReducerName,
    selector: TCustomSelector<TSelected, TReducerName> = (state) => state,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    const selectorMemo = useCallback(
        (state: TRootState) =>
            selector(state[reducerName] || ({} as TRootState[TReducerName])),
        [reducerName, selector]
    );

    return useSelector(selectorMemo, equalityFn);
};
